import "./TutorialModal.css";
import { useEffect, useState } from "react";
import Arrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import Modal from "react-bootstrap/Modal";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { useSelector, useDispatch } from "react-redux";
import BubbleSvgButton from "../BubbleSvgButton/BubbleSvgButton";
import TutorialStart from "./TutorialStart";
import TutorialData from "./TutorialData";
import TutorialInsightfull from "./TutorialInsightfull";
import TutorialDatesCal from "./TutorialDatesCal";
import AskingServices from "./AskingServices";
import { useNavigate } from "react-router-dom";
import { storeUser } from "../../../../redux/users/usersSlice.js";
import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify.js";
import AddTradeName from "../../../VerifyMyTrade/AddTradeName/index.jsx";
import { setRefetchSpecificUser } from "../../../../redux/multicommunity/multicommunity.js";
import LoadingModal from "../../../../components/loader/loadingModal.js";

const TutorialModal = () => {
  const activeSlide = useSelector(
    (state) => state.user?.user?.activeTutorialScreen.activeTutorial
  );
  const purposeOfJoiningUser = useSelector(
    (state) => state.user?.user?.activeTutorialScreen.purposeOfJoining
  );
  const [commmingFor, setCommingFor] = useState(purposeOfJoiningUser || "");
  const [show, setShow] = useState(true);
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [role, setUserRole] = useState(null);
  const api = useApi();

  const handleClose = async () => {
    if (commmingFor !== "Verify Your Trading") {
      const response = await api("post", "authorizeNewonBoard/watchTutorial", {
        purposeOfJoining: commmingFor,
      });
      if (response?.status) {
        await updateScreen(null, "");
        if(user?.role==="leader"&&(!user?.tradeName)){

          showNotificationToast("Welcome onboard!", "Take a look around and hit start when you're ready to launch a copy trade.");
        }
        if(user?.role==="member"){
          showNotificationToast("Welcome! We're happy you've signed up!", " ");
        }
        setShow(false);
        
        navigate(`/${user.role}/dashboard`);
          
      }
    } else {
      // await updateScreen(null, "");
      await updateTraderPopUp(true);
      // setShow(false);
    }
  };
  const handleSwitchClick = async (slideNumber) => {
    await updateScreen(slideNumber, commmingFor);
  };

  async function updateTraderPopUp(showTradeNamePopUp) {
    const response = await api("post", "/users/updateTraderPopUp", {
      showTradeNamePopUp,
    });
    if (response.status) {
        const response = await api("get", "users/index");
        if (response?.status) {
          const { data } = response;
          if (dispatch && storeUser) dispatch(storeUser(data));
          if (data?.token) localStorage.setItem("token", data.token);
        }
    }
    toastify(response?.message);
  }

  async function updateScreen(screen, commmingFor, sendWellcomeEmail) {
    const response = await api("post", "/users/updateTutorialScreen", {
      activeTutorial: screen,
      purposeOfJoining: commmingFor,
      sendWellcomeEmail,
    });
    if (response.status) {
      // if(sendWellcomeEmail &&
      //   sendWellcomeEmail === "Verify Your Trading"){
      //     // showNotificationToast("Welcome onboard!", "Take a look around and hit start when you're ready to start verifying your trading.\n\nDon't forget:\n1) You can verify individual trades!\n2) Set it up to automatically share verified performances on social");
      //   }else if(sendWellcomeEmail &&
      //     sendWellcomeEmail === "Launch Your Own Copy Trade"){
      //       // showNotificationToast("Welcome onboard!", "Take a look around and hit start when you're ready to launch a copy trade.");
      //     }
      const response = await api("get", "users/index");
      if (response?.status) {
        const { data } = response;
        if (dispatch && storeUser) dispatch(storeUser(data));
        if (data?.token) localStorage.setItem("token", data.token);
      }
    }
    toastify(response?.message);
  }
  const handleNext = async (purpose) => {
    if (purpose) {
      await updateScreen(
        user?.activeTutorialScreen.activeTutorial + 1,
        purpose || commmingFor,
        purpose
      );
    } else {
      await updateScreen(
        user?.activeTutorialScreen.activeTutorial + 1,
        purpose || commmingFor
      );
    }

    if (purpose) {
      dispatch(setRefetchSpecificUser(true));
    }
  };

  const handlePrev = async () => {
    await updateScreen(
      user?.activeTutorialScreen.activeTutorial - 1,
      commmingFor
    );
  };

  const hadnleTraderPrevious = async () => {
    await updateTraderPopUp(false);
    await updateScreen(4, "Verify Your Trading");
  };
  useEffect(() => {
    if (Object.keys(user || {})?.length) {
      setShow(!user?.isWatchTutorial);
      setUserRole(user?.role);
    }
  }, [user]);
 
  // useEffect(() => {
  //   async function updateFirstScreeen() {
  //     await updateScreen(user?.role === "leader" ? 0 : 1, "");
  //   }
  //   if (activeSlide === null) {
  //     updateFirstScreeen();
  //   }
  // }, [user]);
  // if (activeSlide === null) {
  //   return <LoadingModal />;
  // }

  return (
    <div className="tutorial-modal-wrapper">
      <Modal
        backdropClassName="custom-backdrop"
        centered
        dialogClassName="custom-tutorial-modal"
        show={show}
        animation={false}
      >
        <Modal.Body>
          <>
            <div className={`tutorial-slide`}>
              {!user?.showTradeNamePopUp && (
                <>
                  {activeSlide > 1 && (
                    <button
                      className="headerArrowBtn"
                      onClick={handlePrev}
                      type="button"
                    >
                      <img alt="" src={Arrow} />
                    </button>
                  )}

                  {activeSlide === 0 && (
                    <div className="shownServicesBox">
                      <AskingServices
                        handleNext={handleNext}
                        setCommingFor={setCommingFor}
                      />
                    </div>
                  )}

                  {activeSlide === 1 && (
                    <TutorialStart
                      title={
                        commmingFor === "Verify Your Trading"
                          ? "Start verifying your trades"
                          : "Start your copy trading"
                      }
                      description="Just hit the green ‘START’ button and follow the instructions"
                    />
                  )}
                  {activeSlide === 2 && (
                    <TutorialData
                      title={user?.role!=="leader"?"Platform data":"No data"}
                      description={
                        commmingFor === "Verify Your Trading"
                          ? "Platform won’t show any data until you’ve started to verify your trades"
                          : user?.role!=="leader"?" Platform will start showing data once you’ve subscribed to a copy trade.":"Until you set up your copy trading and first trades are done"
                      }
                    />
                  )}
                  {activeSlide === 3 && (
                    <TutorialDatesCal
                      title="Dates and calculations"
                      description="Your performance will be calculated from the point you connect your exchange."
                    />
                  )}
                  {activeSlide === 4 && (
                    <TutorialInsightfull
                      title={
                        commmingFor === "Verify Your Trading"
                          ? "Free Insightful Dashboard"
                          : "Set up all the extras"
                      }
                      description={
                        commmingFor === "Verify Your Trading"
                          ? "Use the dashboard for all sorts of free valuable insights into your trading"
                          : "Once started, you can automate a lot. Share result, performance, VIP access, order an app and much more."
                      }
                    />
                  )}
                  {!(activeSlide === 0) && (
                    <>
                      <BubbleSvgButton
                        className="tutorialNextBtn"
                        onClick={() => {
                          if (user?.role==="leader"&&activeSlide === 4) {
                            handleClose();}
                            else if(user?.role!=="leader"&&activeSlide === 2) {
                              handleClose();
                            }
                          else handleNext();
                        }}
                        text={activeSlide === 4 ? "Got it" : "Next"}
                        type="button"
                        variant="black"
                        containerStyling={{
                          justifyContent: "center",
                        }}
                        mainDivStyle={{
                          width: "auto",
                          height: "auto",
                          position: "absolute",
                          left: "50%",
                          bottom: "60px",
                          transform: "translateX(-50%)",
                        }}
                      />

                      <div className="tutorialHeaderBox">
                        <div className="switcher">
                          <button
                            className={`switch ${
                              activeSlide === 1 ? "active" : ""
                            }`}
                            // onClick={() => handleSwitchClick(1)}
                            type="button"
                          ></button>
                          <button
                            className={`switch ${
                              activeSlide === 2 ? "active" : ""
                            }`}
                            // onClick={() => handleSwitchClick(2)}
                            type="button"
                          ></button>
                          {user?.role==="leader"&&
                          <>
                          <button
                            className={`switch ${
                              activeSlide === 3 ? "active" : ""
                            }`}
                            // onClick={() => handleSwitchClick(3)}
                            type="button"
                          ></button>
                          <button
                            className={`switch ${
                              activeSlide === 4 ? "active" : ""
                            }`}
                            // onClick={() => handleSwitchClick(4)}
                            type="button"
                          ></button>
                          </>
                          }
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

              {user?.showTradeNamePopUp && (
                <>
                  <button
                    className="headerArrowBtn"
                    onClick={hadnleTraderPrevious}
                    type="button"
                  >
                    <img alt="" src={Arrow} />
                  </button>
                  <AddTradeName />
                </>
              )}
            </div>
          </>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TutorialModal;
